<template>
  <v-layout>
    <v-flex xs6>
      <Divider>{{ $t('message.tasas.apartado5') }}</Divider>
      <v-container fluid grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 lg4>
            <v-text-field :label="$t('message.comun.nif')" v-model="nif" readonly></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg6>
            <v-text-field
              :label="$t('message.comun.nombre')"
              v-model="declarante"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg10>
            <v-text-field
              :label="$t('message.comun.fecha')"
              v-model="fechaActual"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>

    <v-flex xs6>
      <Divider>{{ $t('message.tasas.apartado6') }}</Divider>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex text-xs-left xs6>{{ $t('message.cuotas.resumen.totalCuota') }} </v-flex>
          <v-flex xs6>
            <Numeric id="totalcuota" v-model="resumen.total" :readonly="true" currency="€"></Numeric
          ></v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex text-xs-left xs6
            >{{ $t('message.cuotas.resumen.iva', { importe: resumen.iva }) }}
          </v-flex>
          <v-flex xs6>
            <Numeric
              id="totalcuota"
              v-model="resumen.importeIva"
              :readonly="true"
              currency="€"
            ></Numeric
          ></v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex text-xs-left xs6>
            <div class="total">{{ $t('message.cuotas.resumen.totalIngreso') }}</div>
          </v-flex>
          <v-flex xs6>
            <div class="total">
              <Numeric
                id="totalfacturacion"
                :value="resumen.totalIngresar"
                readonly
                currency="€"
              ></Numeric>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <Divider>
        <p>
          {{ $t('message.cuotas.resumen.textoIngresar') }}
          {{ resumen.id | datosBancariosEntidad }}
        </p>
        <p>
          {{ $t('message.cuotas.resumen.textoTitular') }}
          {{ resumen.id | datosBancariosTitular }}
        </p>
        <p>
          {{ $t('message.cuotas.resumen.textoCuenta') }}
          {{ resumen.id | datosBancariosIban }}
        </p>
      </Divider>
    </v-flex>
  </v-layout>
</template>
<script>
import { Divider, Numeric } from '@/components';
import moment from 'moment';
export default {
  name: 'declaranteIngreso',
  props: {
    nif: { type: String, required: true },
    declarante: { type: String, required: true },
    resumen: {
      type: Object,
      required: true
    }
  },
  components: {
    Divider,
    Numeric
  },
  computed: {
    fechaActual() {
      return moment().format('DD [de] MMMM [de] YYYY');
    }
  },
  created() {}
};
</script>
